import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Box, Image, Link } from '@theme-ui/components';

import { getButtonStyles } from '@app/components/Button';
import Card from '@app/components/Card';
import { H3 } from '@app/components/typography';
import type { AppTheme } from '@app/styles/theme';
import { rem } from '@app/styles/theme/layout';

import productPortal1x from '../assets/product-portal-1x.png';
import productPortal2x from '../assets/product-portal-2x.png';
import messages from '../Success.messages';
import {
  neutralCardStyles,
  nextStepImageStyles,
  NextStepsGrid,
  nextStepsRowStyles,
} from '../Success.styles';

const ProductPortal = () => {
  const { language = 'en' } = useParams<{ language?: string }>();
  const supportLinkLocale =
    language === 'jp' ? 'ja' : language === 'zh' ? 'zh-cn' : language;
  const productPortalLink = `https://support.native-instruments.com/hc/${supportLinkLocale}/articles/4424725024273-How-to-Register-and-Install-iZotope-Products`;

  return (
    <Card css={neutralCardStyles} data-testid="product-portal">
      <NextStepsGrid>
        <Box sx={{ textAlign: 'center' }} px={[20]} css={nextStepsRowStyles}>
          <H3>
            <FormattedMessage
              data-testid="product-portal-product-title"
              {...messages.getProductPortalTitle}
            />
          </H3>

          <Box sx={{ marginTop: rem(20), marginBottom: rem(20) }}>
            <FormattedMessage {...messages.getProductPortalDescription} />
          </Box>

          <Link
            href={productPortalLink}
            data-testid="product-portal-link"
            css={(theme: AppTheme) =>
              getButtonStyles({ type: 'secondary', theme })
            }
          >
            <FormattedMessage {...messages.learnMore} />
          </Link>
        </Box>

        <Image
          srcSet={`
             ${productPortal1x} 1x,
             ${productPortal2x} 2x`}
          src={productPortal1x}
          alt=""
          css={nextStepImageStyles}
          data-testid="product-portal-image"
        />
      </NextStepsGrid>
    </Card>
  );
};

export default ProductPortal;
